import { Pipe, PipeTransform } from '@angular/core';
import { LocalizationService } from '@cm/core/localization';
import { Observable, map } from 'rxjs';

@Pipe({
	name: 'localize',
	standalone: true,
})
export class LocalizePipe implements PipeTransform {
	constructor(private readonly localizationService: LocalizationService) {}

	transform(name: string): Observable<string> {
		return this.localizationService.find$(name).pipe(map(loc => (loc || {}).value || ''));
	}
}
